<template>
  <div>
    <!-- 验证管理员密码 弹窗 -->
    <InputPasswordDialog
      :isShow="passWordIsShow"
      @personnelStructure="personnelStructure"
      @close="passWordIsShow = false"
      title="输入管理员密码" />
    <!-- 修改企业账号 弹窗 -->
    <el-dialog
      title="企业变更账号"
      center
      width="500px"
      :visible.sync="dialogFormVisible"
      @close="closeDialog">
      <el-form :model="formData" ref="formRef" label-width="80px">
        <el-form-item label="新账号：" prop="telephone">
          <el-input
            maxlength="11"
            placeholder="请输入手机号"
            style="width: 224px"
            v-model="formData.telephone"
            autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="smsCode">
          <el-input
            style="width: 224px"
            placeholder="请输入验证码"
            v-model="formData.smsCode"
            maxlength="6"></el-input>
          <button @click.prevent="getCode()" class="code-btn" :disabled="!show">
            <span v-show="show">获取验证码</span>
            <span v-show="!show" class="count">{{ count }} s</span>
          </button>
        </el-form-item>
        <el-form-item label="" prop="" v-if="showCaptcha">
          <div>
            <div id="captcha-button-account"></div>
            <div id="ali-captcha-account"></div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getsendSmsCode } from "@/api/home";
import { getCaptchaV2 } from "@/utils/aliWaterBox.js";
import { updateEnterpriseAccount, reqCheckPassword } from "@/api/hy";
import InputPasswordDialog from "@/components/InputPasswordDialog.vue";
import md5 from "js-md5";

export default {
  data() {
    return {
      /** 验证管理员密码弹窗开关 */
      passWordIsShow: false,
      /** 变更企业账号弹窗开关 */
      dialogFormVisible: false,
      /** 修改表单数据 */
      formData: {
        /** 手机号 */
        telephone: "",
        /** 验证码 */
        smsCode: "",
      },
      /** 是否显示获取验证码 */
      show: true,
      /** 验证码倒计时 */
      count: 0,
      /** 验证码倒计时计时器 */
      timer: null,
      /** 阿里云滑块验证是否显示 */
      showCaptcha: false,
    };
  },
  components: {
    InputPasswordDialog,
  },
  methods: {
    /** 验证密码弹窗 */
    personnelStructure(e) {
      console.log(e);
      let config = {
        password: md5(e),
        type: 2,
      };
      reqCheckPassword(config).then(res => {
        console.log(res);
        res.code = 0;
        if (res.code == 0) {
          this.dialogFormVisible = true;
        } else {
          this.$confirm(`${res.message}`, "提示", {
            confirmButtonText: "去修改",
            cancelButtonText: "重新输入",
            type: "warning",
          })
            .then(() => {
              this.$router.push({
                path: "/finance",
              });
            })
            .catch(() => {
              this.passWordIsShow = true;
            });
        }
      });
      console.log(e);
    },
    /** 提交修改 */
    handleSubmit() {
      updateEnterpriseAccount(this.formData).then(res => {
        console.log(res);
        if (res.code == 0) {
          this.$message({
            message: "您的账号已变更，请重新登录。",
            type: "success",
          });
          this.closeDialog();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /** 获取验证码 */
    async getCode() {
      if (!this.formData.telephone) {
        this.$YTmsg("请输入手机号码", "error");
        return false;
      }
      if (!this.$verify.phone(this.formData.telephone)) {
        // this.errorType = 11;
        this.$YTmsg("请填写正确的手机号", "error");
        return false;
      }

      /** 阿里防水墙验证 */
      this.showCaptcha = true;
      await this.$nextTick();
      const captchaVerifyParam = await getCaptchaV2(
        "ali-captcha-account",
        "captcha-button-account",
      ).finally(() => {
        this.showCaptcha = false;
      });
      let config = { phone: this.formData.telephone, captchaVerifyParam };
      console.log("config", config);
      //  发送重置密码短信验证码
      let res = await getsendSmsCode({ phone: this.formData.telephone, captchaVerifyParam });
      if (res.code && res.code != 0) {
        return this.$YTmsg(res.message || "验证码发送失败", "error");
      }
      this.$YTmsg("验证码已发送,请注意查收", "success");

      this.count = 60;
      this.show = false;
      this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= 60) {
          this.count--;
        } else {
          this.show = true;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    open() {
      this.passWordIsShow = true;
    },
    /** 关闭修改弹窗 */
    closeDialog() {
      this.$refs.formRef.resetFields();
      clearInterval(this.timer);
      this.show = true;
      this.count = 0;
      this.timer = null;
      this.dialogFormVisible = false;
      this.$parent.getCompanyAuthDetail();
    },
  },
};
</script>

<style lang="scss" scoped>
.count {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-button {
    margin: 0 45px 0 20px;
  }
  span {
    font-weight: bold;
    font-size: 20px;
  }
}

.code-btn {
  width: 100px;
  height: 34px;
  background: linear-gradient(90deg, #2079fb, #4cb2fc);
  border-radius: 4px;
  z-index: 222;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 9px;
  margin-left: 8px;
}
</style>
